// Main App Entry Point — หมออร เชียงใหม่
import { initFirebase } from './firebase.js';
import { initLiff } from './liff.js';
import { loginUser } from './auth.js';
import { registerRoute, setNotFound, startRouter, navigate } from './router.js';

// Pages
import { renderHome } from './pages/home.js';
import { renderBooking } from './pages/booking.js';
import { renderPayment } from './pages/payment.js';
import { renderHistory } from './pages/history.js';
import { renderProfile } from './pages/profile.js';
import { renderAdminSchedule } from './pages/admin-schedule.js';
import { renderAdminBookings } from './pages/admin-bookings.js';
import { renderAdminSettings } from './pages/admin-settings.js';
import { renderAdminReports } from './pages/admin-reports.js';
import { renderAdminFortuneTellers } from './pages/admin-fortune-tellers.js';
import { renderAdminLogin } from './pages/admin-login.js';

async function bootstrap() {
  const t0 = performance.now();

  try {
    // Check if we are doing PIN login
    const isPinPath = window.location.hash.startsWith('#/admin/login');
    const isAdminRoute = window.location.hash.startsWith('#/admin');
    const isPinAuthed = localStorage.getItem('app_pin_auth') === 'true';
    
    // Only use PIN mode if they are explicitly navigating to an admin route
    const isPinMode = isPinPath || (isPinAuthed && isAdminRoute);

    // ⚡ PARALLEL: Init Firebase + LIFF at the same time (saves ~1-2s)
    if (isPinMode) {
      // PIN Mode: Firebase only, skip LIFF entirely
      initFirebase();
      await loginUser(true);
    } else {
      // LINE Mode: Fire both simultaneously, then await results
      const firebasePromise = Promise.resolve(initFirebase());
      const liffPromise = initLiff();
      
      // Wait for both to finish in parallel
      await Promise.all([firebasePromise, liffPromise]);
      
      await loginUser(false);
    }

    // Register routes (sync — instant)
    // Customer routes
    registerRoute('/home', () => renderHome());
    registerRoute('/booking/:id', (params) => renderBooking(params));
    registerRoute('/booking/:id/payment', (params) => renderPayment(params));
    registerRoute('/history', () => renderHistory());
    registerRoute('/profile', () => renderProfile());

    // Admin routes (auth guard inside each page)
    registerRoute('/admin/schedule', () => renderAdminSchedule());
    registerRoute('/admin/bookings', () => renderAdminBookings());
    registerRoute('/admin/settings', () => renderAdminSettings());
    registerRoute('/admin/reports', () => renderAdminReports());
    registerRoute('/admin/fortune-tellers', () => renderAdminFortuneTellers());
    registerRoute('/admin/login', () => renderAdminLogin());

    setNotFound(() => navigate('/home'));

    // Hide loading screen
    const loadingScreen = document.getElementById('loading-screen');
    if (loadingScreen) {
      loadingScreen.classList.add('hidden');
      setTimeout(() => loadingScreen.remove(), 500);
    }

    // Start router
    startRouter();

    const t1 = performance.now();
    console.log(`🔮 หมออร เชียงใหม่ app started in ${Math.round(t1 - t0)}ms`);
  } catch (err) {
    if (err.message === 'FRIEND_REQUIRED') return; // Handled in liff.js

    console.error('Bootstrap error:', err);
    const appEl = document.getElementById('app');
    if (appEl) {
      appEl.innerHTML = `
        <div style="display:flex; align-items:center; justify-content:center; min-height:100dvh; padding:2rem; text-align:center;">
          <div>
            <div style="font-size:4rem; margin-bottom:1rem;">😔</div>
            <h2 style="color:#f87171; margin-bottom:0.5rem;">เกิดข้อผิดพลาด</h2>
            <p style="color:#a89cc8; font-size:0.875rem;">${err.message}</p>
            <button onclick="location.reload()" style="margin-top:1rem; padding:0.5rem 1.5rem; background:linear-gradient(135deg,#9b59f0,#e94d9e); color:white; border:none; border-radius:8px; cursor:pointer;">
              ลองใหม่อีกครั้ง
            </button>
          </div>
        </div>
      `;
    }
  }
}

bootstrap();
